"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=932%3A451))
 * @lastsynced 2026-10-29T13:50:27.860Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const CreditCard = createSVGIcon(
  <path
    d="M.857 9.857h22.286m-6.857 6h2.571m-16.286-12h18.857c.947 0 1.715.768 1.715 1.714V18.43c0 .946-.768 1.714-1.715 1.714H2.572a1.714 1.714 0 0 1-1.714-1.714V5.57c0-.946.768-1.714 1.714-1.714Z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "CreditCard",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
